import { callApiToServer } from "../callApi";

export async function addTestimonial(authtoken, values) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(values);

    let endUrl = "v1/auth/admin/add-testimonial";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
